import { PrintSelectImagesHeader } from "./component/print-select-images.header";
import './print-select-images.scss';
import { PrintSelectImagesTabs } from "./component/print-select-images.tabs";
import { usePrintSelectImages } from "./hooks/use-print-select-images";
import { TrimmingSelectButton } from "./component/trimming-select-button";
import { Button } from "../../../ui/button/button";
import { PrintSelectImageCard } from "./component/print-select-images.card";
import { PrintSelectImagesFooter } from "./component/print-select-images.footer";
import { Select } from "../../../ui/select/select";
import alignLargeOn from '../../../../assets/img/icon/icon_align_large_on.svg';
import alignLargeOff from '../../../../assets/img/icon/icon_align_large_off.svg';
import alignSmallOn from '../../../../assets/img/icon/icon_align_small_on.svg';
import alignSmallOff from '../../../../assets/img/icon/icon_align_small_off.svg';
import imageAddIcon from '../../../../assets/img/icon/insert-image_fill.svg';
import { usePrintStatus } from "../hooks/use-print-status";
import { FaPlus } from "react-icons/fa6";
import { IoInformationCircleOutline } from "react-icons/io5";
import { CiCirclePlus } from 'react-icons/ci';

export const PrintSelectImages = () => {
  const {
    structure,
    buttons,
    images,
    selectOrder,
    themeClassName,
    footerCollapseState,
    loading,
    isInitializing,
    sort,
    align,
    validRotate,
    onSelectImage,
    setSelectImageCount,
    onSelectTab,
    handlerChangeSize,
    handlerReturn,
    handlerSave,
    handlerAddOrder,
    handlerDelete,
    handlerImageUpload,
    handlerAllSelect,
    handlerAllRemove,
    handlerIncrementAll,
    handlerDecrementAll,
    handlerEditTrimming,
    handlerRotate,
    handlerClickDatePrintUsage,
    getRotate,
    thumbImages,
    saveThumbImages,
    isTrimmed,
    loadImage,
  } = usePrintSelectImages();
  usePrintStatus({ isLockedAfterOrder: true });

  return (
    <>
      <div className="print_select_images">
        <div className="layout__header_wrap">
          <PrintSelectImagesHeader
            structure={structure}
          />
        </div>
        <PrintSelectImagesTabs
          theme={themeClassName}
          structure={structure}
          selectId={selectOrder?.id ?? ''}
          onSelect={onSelectTab}
          handlerChangeSize={handlerChangeSize}
          images={images}
          onReturn={() => handlerReturn()}
          onAddOrder={() => handlerAddOrder()}
          onDelete={handlerDelete}
        />
        <div
          className={`print_select_images__body ${themeClassName}`}
        >
          <div className="print_select_images__body__header">
            <div className="print_select_images__body__header__mode_box_title">編集モード</div>
            <div className="print_select_images__button_box">
              <div className="print_select_images__button_box__left">
                <div className={`print_select_images__button_box__left__mode_box ${themeClassName}`}>
                  <TrimmingSelectButton kind="image" label="プリント選択" {...buttons.image} />
                  <TrimmingSelectButton kind="trimming" label="おまかせトリミング" {...buttons.trimming} />
                  <TrimmingSelectButton kind="date" label="日付プリント" {...buttons.date} />
                </div>
                <div className={`print_select_images__button_box__left__all_select ${themeClassName}`}>
                  <h2>
                    画像をクリックして選択
                  </h2>
                  <div className="select_button_box">
                    <Button label="全選択" size="lg" onClick={handlerAllSelect} data-state="all-check" />
                    <Button label="全解除" size="lg" onClick={handlerAllRemove} data-state="all-remove" />
                  </div>
                   {themeClassName === 'theme_date' ? (
                    <div
                      className="theme_date_annotation"
                      onClick={handlerClickDatePrintUsage}
                    >
                      <div className="theme_date_annotation__triangle"></div>
                      <IoInformationCircleOutline size="24px" />
                      <div>日付プリントの仕様についてご確認ください</div>
                    </div>
                  ) : <></>}
                </div>
              </div>
              <div className="print_select_images__button_box__right">
                <Button
                  icon={<CiCirclePlus size="16px" strokeWidth="2px" />}
                  label="画像追加"
                  className="print_select_images__button_box__right__add_image"
                  color="warning"
                  onClick={handlerImageUpload}
                  // icon={<FaPlus size="16px" />}
                />

                <Select {...sort} />
                <div className="view_size_box">
                  <Button
                    label={<img src={align.value ? alignLargeOn : alignLargeOff} alt="align_large" />}
                    className={align.value ? 'is_select' : ''}
                    onClick={() => align.onClick(true)}
                  />
                  <Button
                    label={<img src={!align.value ? alignSmallOn : alignSmallOff} alt="align_small" />}
                    className={!align.value ? 'is_select' : ''}
                    onClick={() => align.onClick(false)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={
            `print_select_images__image_box
            ${footerCollapseState[0] ? 'footer_open' : ''}
            ${align.value ? 'large_view' : ''}
            `}>
              {images.map((v, i) => (
                <PrintSelectImageCard
                  data={v}
                  saveThumbImageList={saveThumbImages}
                  isTrimmed={isTrimmed}
                  key={`${v.id || 0}_${i}`}
                  onClick={onSelectImage}
                  onInputSelect={setSelectImageCount}
                  largeView={align.value}
                  onClickEdit={handlerEditTrimming}
                  onRotate={handlerRotate}
                  validRotate={validRotate}
                  getRotate={getRotate}
                  thumbImages={thumbImages}
                />
              ))}
            </div>
          </div>
          <PrintSelectImagesFooter
            selectOrder={selectOrder}
            footerCollapseState={footerCollapseState}
            onComplete={handlerSave}
            isInitializing={isInitializing}
            structure={structure}
            images={images}
            onInputSelect={setSelectImageCount}
            onAllIncrement={handlerIncrementAll}
            onAllDecrement={handlerDecrementAll}
            saveThumbImageList={saveThumbImages}
            loadImage={loadImage}
          />
      </div>
      <loading.LoadingPopup />
    </>
  )
}
